document.addEventListener('DOMContentLoaded', () => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* mobile navigation */
  const toggle = $('[data-menu-toggle]');
  const nav = $('[data-nav]');
  const closeMobileNav = () => {
    toggle?.setAttribute('aria-expanded', 'false');
    nav?.classList.remove('is-open');
    document.body.classList.remove('mobile-nav-open');
  };
  toggle?.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    if (open) {
      closeMobileNav();
    } else {
      toggle.setAttribute('aria-expanded', 'true');
      nav?.classList.add('is-open');
      document.body.classList.add('mobile-nav-open');
    }
  });
  nav?.addEventListener('click', event => {
    if (event.target.closest('a')) closeMobileNav();
  });
  document.addEventListener('click', event => {
    if (!nav?.classList.contains('is-open')) return;
    if (event.target.closest('[data-menu-toggle]') || event.target.closest('[data-nav]')) return;
    closeMobileNav();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && nav?.classList.contains('is-open')) closeMobileNav();
  });

  /* toast */
  let toastTimer;
  const toast = (msg) => {
    const el = $('#LwToast'); if (!el) return;
    el.textContent = msg; el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-on'), 2400);
  };

  /* drawers */
  let lastFocus = null;
  const openDrawer = (id) => {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    document.body.classList.add('drawer-open');
    d.querySelector('button, a, input')?.focus();
  };
  const closeDrawers = () => {
    $$('.drawer.is-open').forEach(d => d.classList.remove('is-open'));
    document.body.classList.remove('drawer-open');
    lastFocus?.focus(); lastFocus = null;
  };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openDrawer(o.dataset.open); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawers(); });

  const drawerOn = document.body.dataset.cartDrawer === 'on';
  const shopRoot = window.Shopify?.routes?.root || '/';
  const cartRoute = (path) => {
    const value = String(path);
    return `${shopRoot}${value.charAt(0) === '/' ? value.slice(1) : value}`;
  };
  const cartFetch = async (path, options = {}) => {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 10000);
    try {
      return await fetch(cartRoute(path), { ...options, signal: controller.signal });
    } finally {
      window.clearTimeout(timeout);
    }
  };
  let quickCartState = null;

  const syncQuickCart = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return;
    quickCartState = cart;
    const quantities = new Map();
    cart.items.forEach(item => {
      const id = String(item.variant_id);
      quantities.set(id, (quantities.get(id) || 0) + item.quantity);
    });
    $$('[data-quick-cart]').forEach(control => {
      const quantity = quantities.get(String(control.dataset.variantId)) || 0;
      const value = $('[data-quick-quantity]', control);
      const minus = $('[data-quick-minus]', control);
      const plus = $('[data-quick-plus]', control);
      if (value) value.textContent = quantity;
      if (minus) minus.disabled = quantity <= 0;
      if (plus && !control.classList.contains('is-loading')) plus.disabled = false;
    });
  };

  /* refresh the basket drawer via the Section Rendering API */
  async function refreshCart(open) {
    try {
      const res = await cartFetch('cart?sections=cart-drawer');
      const data = await res.json();
      const html = data['cart-drawer'];
      if (html) {
        const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('CartDrawer');
        const cur = document.getElementById('CartDrawer');
        if (fresh && cur) {
          const wasOpen = cur.classList.contains('is-open');
          cur.innerHTML = fresh.innerHTML;
          if (wasOpen || open) { cur.classList.add('is-open'); document.body.classList.add('drawer-open'); }
        }
      }
      const cart = await (await cartFetch('cart.js')).json();
      $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      syncQuickCart(cart);
      return cart;
    } catch (err) { console.error(err); }
  }

  if ($('[data-quick-cart]')) {
    cartFetch('cart.js', { headers: { Accept: 'application/json' } })
      .then(response => response.json())
      .then(syncQuickCart)
      .catch(() => {});
  }

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-quick-plus], [data-quick-minus]');
    if (!button) return;
    event.preventDefault();

    const control = button.closest('[data-quick-cart]');
    if (!control || control.classList.contains('is-loading')) return;

    const variantId = Number(control.dataset.variantId);
    if (!variantId) return;

    control.classList.add('is-loading');
    $$('button', control).forEach(item => { item.disabled = true; });

    try {
      if (button.matches('[data-quick-plus]')) {
        const response = await cartFetch('cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        const data = await response.json();
        if (!response.ok) {
          toast(data.description || control.dataset.errorText);
          return;
        }
        await refreshCart(false);
        toast(`${control.dataset.productTitle} — ${control.dataset.addedText}`);
      } else {
        const cart = quickCartState || await (await cartFetch('cart.js', { headers: { Accept: 'application/json' } })).json();
        const item = cart.items.find(cartItem => Number(cartItem.variant_id) === variantId);
        if (!item) {
          syncQuickCart(cart);
          return;
        }

        const response = await cartFetch('cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: Math.max(0, item.quantity - 1) })
        });
        const data = await response.json();
        if (!response.ok) {
          toast(data.description || control.dataset.errorText);
          return;
        }
        syncQuickCart(data);
        await refreshCart(false);
        toast(`${control.dataset.productTitle} — ${control.dataset.removedText}`);
      }
    } catch (err) {
      toast(control.dataset.errorText);
    } finally {
      control.classList.remove('is-loading');
      const quantity = Number($('[data-quick-quantity]', control)?.textContent || 0);
      const minus = $('[data-quick-minus]', control);
      const plus = $('[data-quick-plus]', control);
      if (minus) minus.disabled = quantity <= 0;
      if (plus) plus.disabled = false;
    }
  });

  /* add to cart */
  $$('[data-product-form]').forEach(form => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const old = button.textContent;
      button.disabled = true; button.textContent = button.dataset.addingText || 'Adding...';
      try {
        const response = await cartFetch('cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const data = await response.json();
        if (!response.ok) { toast(data.description || 'Could not add that'); return; }
        if (drawerOn) { await refreshCart(true); toast(`${data.product_title} — ${button.dataset.addedText || 'added to your bag'}`); }
        else { window.location.href = cartRoute('cart'); }
      } catch (err) { toast(button.dataset.errorText || 'Something went wrong. Try again.'); }
      finally { button.disabled = false; button.textContent = old; }
    });
  });

  /* basket line quantities */
  async function changeLine(line, qty) {
    await cartFetch('cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity: qty })
    });
    if (document.querySelector('.cart-page')) { window.location.reload(); return; }
    refreshCart(false);
  }
  document.addEventListener('click', (e) => {
    const row = e.target.closest('[data-line]'); if (!row) return;
    const line = parseInt(row.dataset.line, 10);
    const input = row.querySelector('[data-qty-input]');
    if (e.target.closest('[data-qty-up]')) changeLine(line, parseInt(input.value, 10) + 1);
    else if (e.target.closest('[data-qty-down]')) changeLine(line, Math.max(0, parseInt(input.value, 10) - 1));
    else if (e.target.closest('[data-qty-remove]')) changeLine(line, 0);
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-qty-input]'); if (!input) return;
    changeLine(parseInt(input.closest('[data-line]').dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* multi-option variant selectors (Scent, Container, etc.) */
  $$('[data-product-form]').forEach(form => {
    const selects = $$('[data-option-selector]', form);
    if (!selects.length) return;
    const orderedSelects = [...selects].sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
    const dataEl = $('[data-variant-data]', form);
    const variantIdInput = $('[data-variant-id]', form);
    const priceEl = $('[data-variant-price]');
    const stockEl = $('[data-stock-note]');
    const addButton = $('[data-add-to-cart-button]', form);
    if (!dataEl || !variantIdInput) return;

    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    const variantEntries = Object.entries(variants);
    const optionValue = (variant, index) => variant['option' + (index + 1)];
    const optionCatalog = orderedSelects.map((select, index) => {
      const values = [];
      variantEntries.forEach(([, variant]) => {
        const value = optionValue(variant, index);
        if (value != null && !values.includes(value)) values.push(value);
      });
      return values.map(value => ({ value, text: value }));
    });

    const refreshSelectors = (preferredValues = []) => {
      const chosenValues = [];

      orderedSelects.forEach((select, index) => {
        const allowedValues = new Set(
          variantEntries
            .filter(([, variant]) =>
              chosenValues.every((value, previousIndex) => optionValue(variant, previousIndex) === value)
            )
            .map(([, variant]) => optionValue(variant, index))
            .filter(value => value != null)
        );

        const currentValue = select.value;
        const preferredValue = preferredValues[index];
        const options = optionCatalog[index]
          .filter(item => allowedValues.has(item.value))
          .map(item => {
            const option = document.createElement('option');
            option.value = item.value;
            option.textContent = item.text;
            return option;
          });

        select.replaceChildren(...options);

        if (preferredValue && allowedValues.has(preferredValue)) select.value = preferredValue;
        else if (currentValue && allowedValues.has(currentValue)) select.value = currentValue;
        else if (select.options.length) select.selectedIndex = 0;

        chosenValues.push(select.value);
      });
    };

    const findVariant = () => {
      const chosen = orderedSelects.map(select => select.value);
      return variantEntries.find(([, variant]) =>
        chosen.every((value, index) => optionValue(variant, index) === value)
      );
    };

    const applyVariant = (syncGallery = true) => {
      const match = findVariant();
      if (!match) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = addButton.dataset.unavailableText || 'Unavailable';
        }
        return;
      }

      const [id, variant] = match;
      variantIdInput.value = id;
      if (priceEl) priceEl.innerHTML = variant.priceHtml;
      if (stockEl) stockEl.innerHTML = variant.stockHtml;
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? variant.addLabel : variant.soldOutLabel;
      }

      if (syncGallery) {
        const gallery = form.closest('.product-layout')?.querySelector('[data-product-gallery]');
        gallery?.dispatchEvent(new CustomEvent('product:variant-media', {
          detail: { mediaId: variant.featuredMediaId, imageId: variant.featuredImageId }
        }));
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url.toString());
    };

    orderedSelects.forEach(select => {
      select.addEventListener('change', () => {
        refreshSelectors();
        applyVariant();
      });
    });

    form.addEventListener('product:gallery-image-selected', event => {
      const imageId = String(event.detail?.imageId || '');
      if (!imageId) return;

      const currentValues = orderedSelects.map(select => select.value);
      const candidates = variantEntries.filter(([, variant]) =>
        String(variant.featuredImageId || '') === imageId
      );
      if (!candidates.length) return;

      const [id, variant] = candidates
        .map(entry => ({
          entry,
          score: currentValues.reduce(
            (total, value, index) => total + (optionValue(entry[1], index) === value ? 1 : 0),
            0
          )
        }))
        .sort((a, b) => b.score - a.score)[0].entry;

      const preferredValues = orderedSelects.map((_, index) => optionValue(variant, index));
      refreshSelectors(preferredValues);
      applyVariant(false);
      variantIdInput.value = id;
    });

    refreshSelectors();
    applyVariant();
  });

  /* fullscreen product image gallery and click-to-zoom */
  $$('[data-product-gallery]').forEach(gallery => {
    const slides = $$('[data-gallery-slide]', gallery);
    const thumbnails = $$('[data-gallery-thumbnail]', gallery);
    const galleryCounter = $('[data-gallery-counter]', gallery);
    const productForm = gallery.closest('.product-layout')?.querySelector('[data-product-form]');
    let galleryIndex = Math.max(0, slides.findIndex(slide => !slide.hidden));

    const showGalleryImage = (index, syncVariant = true) => {
      if (!slides.length) return;
      galleryIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== galleryIndex; });
      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        thumbnail.setAttribute('aria-current', String(thumbnailIndex === galleryIndex));
      });
      if (galleryCounter) galleryCounter.textContent = `${galleryIndex + 1} / ${slides.length}`;
      if (syncVariant && productForm) {
        const imageId = String(slides[galleryIndex].dataset.imageId || '');
        if (imageId) {
          productForm.dispatchEvent(new CustomEvent('product:gallery-image-selected', { detail: { imageId } }));
        }
      }
    };

    showGalleryImage(galleryIndex, false);

    $('[data-gallery-prev]', gallery)?.addEventListener('click', () => showGalleryImage(galleryIndex - 1));
    $('[data-gallery-next]', gallery)?.addEventListener('click', () => showGalleryImage(galleryIndex + 1));
    thumbnails.forEach(thumbnail => thumbnail.addEventListener('click', () => showGalleryImage(parseInt(thumbnail.dataset.galleryIndex, 10))));
    $('[data-gallery-stage]', gallery)?.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); showGalleryImage(galleryIndex - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); showGalleryImage(galleryIndex + 1); }
    });
    gallery.addEventListener('product:variant-media', event => {
      const mediaId = String(event.detail?.mediaId || '');
      const imageId = String(event.detail?.imageId || '');
      const targetIndex = slides.findIndex(slide =>
        (mediaId && slide.dataset.mediaId === mediaId) ||
        (imageId && slide.dataset.imageId === imageId)
      );
      if (targetIndex >= 0) showGalleryImage(targetIndex, false);
    });

    const media = $$('[data-product-media]', gallery);
    const section = gallery.closest('.page-editor-shell');
    const lightbox = $('[data-product-lightbox]', section || document);
    if (!media.length || !lightbox) return;

    const image = $('[data-lightbox-image]', lightbox);
    const frame = $('[data-lightbox-frame]', lightbox);
    const counter = $('[data-lightbox-counter]', lightbox);
    const zoomButton = $('[data-lightbox-zoom]', lightbox);
    const closeButton = $('[data-lightbox-close]', lightbox);
    const zoomEnabled = lightbox.dataset.zoomEnabled === 'true';
    const zoomLabel = lightbox.dataset.zoomLabel || 'Zoom';
    const zoomOutLabel = lightbox.dataset.zoomOutLabel || 'Zoom out';
    const zoomLevel = Math.max(1.5, (parseInt(lightbox.dataset.zoomLevel, 10) || 200) / 100);
    let current = 0;
    let trigger = null;

    lightbox.style.setProperty('--lightbox-zoom', zoomLevel);

    const setZoom = (on) => {
      if (!zoomEnabled) return;
      frame.classList.toggle('is-zoomed', on);
      image.style.transformOrigin = 'center';
      if (zoomButton) {
        zoomButton.setAttribute('aria-pressed', String(on));
        zoomButton.textContent = on ? zoomOutLabel : zoomLabel;
      }
    };

    const showImage = (index, syncVariant = true) => {
      current = (index + media.length) % media.length;
      const selected = media[current];
      image.src = selected.dataset.fullImage;
      image.alt = selected.dataset.imageAlt || '';
      if (counter) counter.textContent = `${current + 1} / ${media.length}`;
      setZoom(false);
      if (syncVariant) showGalleryImage(current);
    };

    const openLightbox = (index, source) => {
      trigger = source;
      showImage(index, false);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lightbox-open');
      closeButton?.focus();
    };

    const closeLightbox = () => {
      setZoom(false);
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lightbox-open');
      trigger?.focus();
      trigger = null;
    };

    media.forEach((button, index) => button.addEventListener('click', () => openLightbox(index, button)));
    $$('[data-lightbox-close]', lightbox).forEach(button => button.addEventListener('click', closeLightbox));
    $('[data-lightbox-prev]', lightbox)?.addEventListener('click', () => showImage(current - 1));
    $('[data-lightbox-next]', lightbox)?.addEventListener('click', () => showImage(current + 1));
    zoomButton?.addEventListener('click', () => setZoom(!frame.classList.contains('is-zoomed')));
    if (zoomEnabled) image.addEventListener('click', () => setZoom(!frame.classList.contains('is-zoomed')));
    image.addEventListener('mousemove', (event) => {
      if (!frame.classList.contains('is-zoomed')) return;
      const bounds = image.getBoundingClientRect();
      const x = ((event.clientX - bounds.left) / bounds.width) * 100;
      const y = ((event.clientY - bounds.top) / bounds.height) * 100;
      image.style.transformOrigin = `${x}% ${y}%`;
    });
    lightbox.addEventListener('click', event => { if (event.target === lightbox) closeLightbox(); });
    document.addEventListener('keydown', event => {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') showImage(current - 1);
      if (event.key === 'ArrowRight') showImage(current + 1);
    });
  });

  /* filters apply themselves */
  let facetTimer;
  const applyFacets = (form) => {
    const params = new URLSearchParams(new FormData(form)).toString();
    window.location.href = window.location.pathname + (params ? '?' + params : '');
  };
  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-facet-form]'); if (!form) return;
    clearTimeout(facetTimer); facetTimer = setTimeout(() => applyFacets(form), 280);
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-facet-form]'); if (!form) return;
    e.preventDefault(); applyFacets(form);
  });

  /* sort */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-sort]'); if (!sel) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value); url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  if (document.startViewTransition) document.documentElement.classList.add('has-view-transitions');
});
